import _ from 'lodash';
import Backbone from 'backbone';
import PresentationModel from 'models/properties/presentationModel';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';

const SiteSectionPropertyModel = Backbone.Model.extend({
    idAttribute: 'uuid',
    urlRoot: '/api/section-property',
    defaults: {
        uuid: null,
        type: 'SectionProperty',
        version: 1,
        name: null,
        pathUrl: null,
        adZone: null,
        children: null,
        templateId: null,
        savedDate: null,
        status: 'draft',
        publishAuthorizationDate: null,
        unpublishAuthorizationDate: null,
        parentSite: {
            uuid: null,
        },
        presentations: [],
        parentSection: {
            type: 'SectionProperty',
            uuid: null,
        },
        parentChannelProperty: {
            type: 'WebSite',
            uuid: '',
        },
        data: {
            injectedMarkup: null,
        },
    },
    initialize() {
        this.legacyRestShim = true;
        this.set('indexPresentation', new PresentationModel());
        bindAllMethods(this);
    },
    parse(data) {
        const model = data && (_.isArray(data.data) && data.data.length > 0) ? data.data[0] : data;
        if (model.indexPresentation) {
            model.indexPresentation = new PresentationModel(model.indexPresentation);
        }

        return model;
    },
    getModelId() {
        return this.get('uuid');
    },
    setModelId(uuid) {
        this.set({uuid});
    },

    getName() {
        return this.get('name');
    },
    setName(name) {
        this.set({name});
    },

    getType() {
        return this.get('type');
    },
    setType(type) {
        this.set({type});
    },

    getOrder() {
        return this.get('order');
    },
    setOrder(order) {
        this.set({order});
    },

    getTemplateId() {
        return this.get('templateId');
    },
    setTemplateId(templateId) {
        this.set({templateId});
    },

    getAdzone() {
        return this.get('adZone');
    },
    setAdzone(zone) {
        this.set({adZone: zone});
    },

    getLocked() {
        return this.get('locked');
    },
    setLocked(locked) {
        this.set({locked});
    },

    getStatus() {
        return this.get('status');
    },
    setStatus() {
        this.set({status});
    },
    getPathUrl() {
        return this.get('pathUrl');
    },
    setPathUrl(path) {
        this.set({pathUrl: path});
    },

    getConfig() {
        return this.get('config');
    },
    setConfig(config) {
        this.set({config});
    },

    getVersion() {
        return this.get('version');
    },
    setVersion(version) {
        this.set({version});
    },

    getCreated() {
        return this.get('created');
    },
    setCreated(created) {
        this.set({created});
    },

    getChildren() {
        return this.get('children');
    },
    setChildren(child) {
        const children = this.getChildren();

        if (!children.includes(child)) {
            children.push(child);
        }

        this.set({children});
    },

    getSavedDate() {
        return this.get('savedDate');
    },
    setSavedDate(date) {
        this.set({savedDate: date});
    },

    getPublishAuthorizationDate() {
        return this.get('publishAuthorizationDate');
    },
    setPublishAuthorizationDate(date) {
        this.set({publishAuthorizationDate: date});
    },

    getUnpublishAuthorizationDate() {
        return this.get('unpublishAuthorizationDate');
    },
    setUnpublishAuthorizationDate(date) {
        this.set({unpublishAuthorizationDate: date});
    },

    getParentSite() {
        return this.get('parentSite');
    },
    setParentSite(parent) {
        this.set({parentSite: {uuid: parent}});
    },

    getGoLiveDate() {
        return this.get('goLiveDate');
    },
    setGoLiveDate(date) {
        this.set({goLiveDate: date});
    },

    getTakeDownDate() {
        return this.get('takeDownDate');
    },
    setTakeDownDate(date) {
        this.set({takeDownDate: date});
    },

    getPropertyTags() {
        return this.get('propertyTags');
    },
    setPropertyTags(tag) {
        const tags = this.getPropertyTags();

        if (!tags.includes(tag)) {
            tags.push(tag);
        }

        this.set({propertyTags: tags});
    },

    getPresentations() {
        return this.get('presentations');
    },
    setPresentations(presentation) {
        const presentations = this.getPresentations();

        if (!presentations.includes(presentation)) {
            presentations.push(presentation);
        }

        this.set({presentations});
    },

    getParentSection() {
        return this.get('parentSection');
    },
    setParentSection(section) {
        this.set({parentSection: {type: 'SectionProperty', uuid: section}});
    },

    getUniversalSections() {
        return this.get('universalSections');
    },
    setUniversalSections(section) {
        const sections = this.getUniversalSections();

        if (!sections.includes(section)) {
            sections.push(section);
        }

        this.set({universalSections: sections});
    },

    getPropertyAttributes() {
        return this.get('propertyAttributes');
    },
    setPropertyAttributes(attr) {
        const attrs = this.getPropertyAttributes();

        if (!attrs.includes(attr)) {
            attrs.push(attr);
        }

        this.set({propertyAttributes: attrs});
    },

    getInjectedMarkup() {
        return this.get('data.injectedMarkup');
    },
    setInjectedMarkup(markup) {
        this.set({data: {injectedMarkup: markup}});
    },

    getParentChannelProperty() {
        return this.get('parentChannelProperty');
    },
    setParentChannelProperty(channel) {
        this.set({parentChannelProperty: {type: 'WebSite', uuid: channel}});
    },
    _setState(state, options = {}) {
        const opts = Object.assign(
            {
                url: `/platform/property/status/${this.get('uuid')}/${state}`,
                method: 'POST',
            },
            options,
        );

        return this.save({}, opts);
    },
    publish(options) {
        return this._setState('PUBLISHED', options);
    },
    unpublish(options) {
        return this._setState('UNPUBLISHED', options);
    },
});

export default SiteSectionPropertyModel;
